import React, { useState, useEffect } from 'react';
import QAViewer from './QAViewer';
import TabViewer from './TabViewer';
import InfoViewer from './Info_Viewer';
import RowViewer from './RowViewer';
import RandomizeViewer from './RandomizeViewer';
import IdentifierViewer from './IdentifierViewer';
import { WidgetTypes } from '../../../constants/QuestionTypes';
import DataTableViewer from './DataTableViewer';
import FilterViewer from './FilterViewer';
import REDCapSurveyViewer from './REDCapSurveyViewer';
import DisplayEditInfoViewer from './DisplayEditInfoViewer';

const WidgetViewer = ({ Widget, Form_ID, Form_BehaviorOnLoad, Form_BehaviorOnSave, Question_Number, CliValidation_Action, CliValidation_ActionWidgetID, OnUpdate, SurveyMode, PrimaryKey, PK_Name, Project_ID, LightMode, FilterParametersList, onSubmitFilterParameters, selectedInstitution, Response, Form_SecondaryIDName, Form_SecondaryIDValue, Custom_Save, widgetsQA, preloadFormData, dataElements, infoConfig, sharedDataElement, resultSource }) => {
	const handleSubmitFilterParameters = (SubmittedFilteredParametersList) => {
		onSubmitFilterParameters(SubmittedFilteredParametersList);
	};

	const [triggerRender, settriggerRender] = useState(false),
		  [selectedInst, setselectedInst] = useState(selectedInstitution),
		  [Responses, setResponses] = useState(Response),
		  [action, setAction] = useState(CliValidation_Action);
	
	useEffect(() => {
		if (Widget.Widget_Type_ID === WidgetTypes.QA &&
			CliValidation_Action !== undefined && (CliValidation_Action.includes('AUTOFILL')) &&
			CliValidation_ActionWidgetID !== undefined && (CliValidation_ActionWidgetID == Widget.Widget_ID)) {
			setAction(CliValidation_Action);
		}
	}, [CliValidation_Action, CliValidation_ActionWidgetID, Widget]);

	return (
			<div>
			{(Widget.Widget_Type_ID === WidgetTypes.QA &&
				CliValidation_Action !== undefined && (CliValidation_Action.includes('AUTOFILL')) &&
				CliValidation_ActionWidgetID !== undefined && (CliValidation_ActionWidgetID == Widget.Widget_ID)) &&
				<QAViewer
					key={action}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					Form_BehaviorOnLoad={Form_BehaviorOnLoad}
					Form_BehaviorOnSave={Form_BehaviorOnSave}
					Question_Number={Question_Number}
					CliValidation_Action={action}
					CliValidation_ActionWidgetID={CliValidation_ActionWidgetID}
					OnUpdate={OnUpdate}
					SurveyMode={SurveyMode}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
					selectedInst={selectedInst}
					Form_SecondaryIDName={Form_SecondaryIDName}
					Form_SecondaryIDValue={Form_SecondaryIDValue}
					widgetsQA={widgetsQA}
					preloadFormData={preloadFormData}
					Question_ID={(widgetsQA.filter((w) => w.Widget_ID == parseInt(Widget.Widget_ID)))[0].Question_ID || null}
				/>
			}
			{
				((Widget.Widget_Type_ID === WidgetTypes.QA &&
					CliValidation_Action !== undefined && (CliValidation_Action.includes('SHOW')) &&
					CliValidation_ActionWidgetID !== undefined && (CliValidation_ActionWidgetID == Widget.Widget_ID))
					||
					(Widget.Widget_Type_ID === WidgetTypes.QA &&
						CliValidation_ActionWidgetID === undefined))
				&&
				<QAViewer
					key={action}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					Form_BehaviorOnLoad={Form_BehaviorOnLoad}
					Form_BehaviorOnSave={Form_BehaviorOnSave}
					Question_Number={Question_Number}
					CliValidation_Action={action}
					CliValidation_ActionWidgetID={CliValidation_ActionWidgetID}
					OnUpdate={OnUpdate}
					SurveyMode={SurveyMode}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
					selectedInst={selectedInst}
					Form_SecondaryIDName={Form_SecondaryIDName}
					Form_SecondaryIDValue={Form_SecondaryIDValue}
					widgetsQA={widgetsQA}
					preloadFormData={preloadFormData}
					Question_ID={((widgetsQA.filter((w) => w.Widget_ID == parseInt(Widget.Widget_ID))).length>0 && (widgetsQA.filter((w) => w.Widget_ID == parseInt(Widget.Widget_ID)))[0].Question_ID) || null} //Test for other projects
				/>
			}

			{Widget.Widget_Type_ID === WidgetTypes.Tabs &&
				<TabViewer
					key={triggerRender}
					PrimaryKey={PrimaryKey}
					PK_Name={PK_Name}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					selectedInst={selectedInst}
					Responses={Responses}
					Question_Number={Question_Number}
					SurveyMode={SurveyMode}
					Project_ID={Project_ID}
					Form_SecondaryIDName={Form_SecondaryIDName}
					Form_SecondaryIDValue={Form_SecondaryIDValue}
				/>
			}

			{Widget.Widget_Type_ID === WidgetTypes.DataTable && (
				<DataTableViewer
					key={'V' + Widget.Widget_ID}
					Form_ID={Form_ID}
					Widget_ID={Widget.Widget_ID}
					LightMode={LightMode}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
					FilterParametersList={FilterParametersList}
					selectedInst={selectedInst}
					Form_SecondaryIDName={Form_SecondaryIDName}
					Form_SecondaryIDValue={Form_SecondaryIDValue}
				/>
			)}

			{
				((Widget.Widget_Type_ID == WidgetTypes.Info && !Widget.hasCustomClientValidation) ||
					(Widget.Widget_Type_ID == WidgetTypes.Info &&
						(Widget.hasCustomClientValidation && (CliValidation_Action !== undefined && CliValidation_Action.includes('SHOW')) &&
							(CliValidation_ActionWidgetID !== undefined && CliValidation_ActionWidgetID == Widget.Widget_ID)
						)
					)
				)
				&&
				(
					<InfoViewer
						key={action}
						Project_ID={Project_ID}
						Widget_ID={Widget.Widget_ID}
						Widget_Color={Widget.Widget_Color}
						Widget_Type_ID={Widget.Widget_Type_ID}
						Form_ID={Form_ID} 
						selectedInst={selectedInst}
						dataElements={dataElements}
						infoConfig={infoConfig}
						sharedDataElement={sharedDataElement}
						resultSource={resultSource}
						Col_ID={Widget.Widget_ID}
						/>
				)
			}

			{/* Button Widget: Reuse Info widget for button */}
			{Widget.Widget_Type_ID === WidgetTypes.Button &&
				<InfoViewer 
					key={'V' + Widget.Widget_ID} 
					Project_ID={Project_ID}
					Form_ID={Form_ID} 
					Widget_ID={Widget.Widget_ID} 
					Widget_Type_ID={Widget.Widget_Type_ID} 
					PrimaryKey={PrimaryKey}
					Widget_Color={Widget.Widget_Color}
					Custom_Save={Custom_Save}
					selectedInst={selectedInst}
				/>
			}

			{/* Randomize Button Widget: Reuse Info widget content */}
			{Widget.Widget_Type_ID === WidgetTypes.Randomize &&
				<RandomizeViewer 
					key={'V' + Widget.Widget_ID} 
					Project_ID={Project_ID}
					Form_ID={Form_ID} 
					Widget_ID={Widget.Widget_ID} 
					Widget_Type_ID={Widget.Widget_Type_ID} 
					PrimaryKey={PrimaryKey}
					SurveyMode={SurveyMode}
					buttonColor='#4BB543'
				/>
			}

			{
				((Widget.Widget_Type_ID === WidgetTypes.Row && !Widget.hasCustomClientValidation) ||
					(Widget.Widget_Type_ID === WidgetTypes.Row &&
						((CliValidation_Action !== undefined && CliValidation_Action !== '' && CliValidation_Action.includes('SHOW')) &&
							(CliValidation_ActionWidgetID !== undefined && CliValidation_ActionWidgetID === Widget.Widget_ID)
						)
					)
				)
				&&
				(
					<RowViewer
						key={action}
						Widget_ID={Widget.Widget_ID}
						Form_ID={Form_ID}
						Question_Number={Question_Number}
						OnUpdate={OnUpdate}
						SurveyMode={SurveyMode}
						PrimaryKey={PrimaryKey}
						Project_ID={Project_ID}
						selectedInst={selectedInst}
						Form_BehaviorOnLoad={Form_BehaviorOnLoad}
						Form_BehaviorOnSave={Form_BehaviorOnSave}
						Form_SecondaryIDName={Form_SecondaryIDName}
						Form_SecondaryIDValue={Form_SecondaryIDValue}
						widgetsQA={widgetsQA}
						preloadFormData={preloadFormData}
						dataElements={dataElements}
						infoConfig={infoConfig}
						sharedDataElement={sharedDataElement}
						resultSource={resultSource}
					/>
				)}

			{Widget.Widget_Type_ID === WidgetTypes.Filter && (
				<FilterViewer key={'V' + Widget.Widget_ID} Widget_ID={Widget.Widget_ID} Form_ID={Form_ID} FilterParametersList={FilterParametersList} onSubmitFilterParameters={handleSubmitFilterParameters} />
			)}

			{Widget.Widget_Type_ID === WidgetTypes.Identifier && (
				<IdentifierViewer
					key={triggerRender}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					Question_Number={Question_Number}
					OnUpdate={OnUpdate}
					SurveyMode={SurveyMode}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
				/>
			)}
			{/* REDCap Preview */}
			{Widget.Widget_Type_ID === WidgetTypes.REDCapForm && (
				<REDCapSurveyViewer
					key={'V' + Widget.Widget_ID}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
				/>
			)}

			{Widget.Widget_Type_ID === WidgetTypes.DisplayEditInfo && (
				<DisplayEditInfoViewer
					key={'V' + Widget.Widget_ID}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
				/>
			)}
		</div>
	);
};

export default WidgetViewer;
